import { generateTestId } from "@client-shared";

export const setStepProgressTestId = (identifier: string): string => generateTestId("StepProgress", identifier);

export const setStepProgressItemTestId = (identifier: string): string => generateTestId("StepProgressItem", identifier);
